<template>
  <section id="settings" class="container main-container">
    <div class="zcolumns">
      <div class="zcolumn zhas-background-primary col1">
        <h3>Ajustes de la Galería</h3>

        <transition name="fade">
          <p v-if="showSuccess" class="success">Galería modificada</p>
        </transition>

        <form @submit.prevent>
          <label for="name">Nombre</label>
          <input
            v-model.trim="gallery.name"
            type="text"
            :placeholder="gallery.name"
            id="name"
          />

          <label for="visible">Visible</label>
          <input
            class="checkbox"
            type="checkbox"
            v-model.trim="gallery.visible"
            id="visible"
          />

          <label for="detectText">Detectar dorsales</label>
          <input type="checkbox" v-model="gallery.detectText" id="detectText" />

          <label for="detectColors">Detectar color de camiseta si no hay dorsal</label>
          <input type="checkbox" v-model="gallery.detectColors" id="detectColors" />

          <label for="numbersFrom">Dorsales Desde</label>
          <input
            v-model.trim="gallery.numbersFrom"
            type="numeric"
            :placeholder="gallery.numbersFrom"
            id="numbersFrom"
          />

          <label for="numbersTo">Dorsales Hasta</label>
          <input
            v-model.trim="gallery.numbersTo"
            type="numeric"
            :placeholder="gallery.numbersTo"
            id="numbersTo"
          />

          <label for="date_start">Fecha inicio</label>
          <input
            v-model.trim="gallery.date_start"
            type="text"
            placeholder="YYYY-MM-DD"
            id="date_start"
          />

          <label for="date_end">Fecha fin</label>
          <input
            v-model.trim="gallery.date_end"
            type="text"
            placeholder="YYYY-MM-DD"
            id="date_end"
          />

          <label for="gmt">GMT</label>
          <input
            v-model.trim="gallery.gmt"
            type="numeric"
            :placeholder="gallery.gmt"
            id="gmt"
          />

          <label for="validateNumbersToBuy">Validar Dorsales para comprar</label>
          <input
            v-model.trim="gallery.validateNumbersToBuy"
            type="checkbox"
            :placeholder="gallery.validateNumbersToBuy"
            id="validateNumbersToBuy"
          />

          <hr />
          <h3>Información adicional (visible en la web)</h3>

          <label for="description">Descripción</label>
          <textarea
            v-model.trim="gallery.description"
            class="xtextarea"
            :placeholder="gallery.description"
            id="description"
          ></textarea>

          <label for="place">Lugar</label>
          <input
            v-model.trim="gallery.place"
            type="text"
            :placeholder="gallery.place"
            id="place"
          />

          <label for="dates">Fechas</label>
          <input
            v-model.trim="gallery.dates"
            type="text"
            :placeholder="gallery.dates"
            id="dates"
          />

          <label for="sport">Deporte</label>
          <input
            v-model.trim="gallery.sport"
            type="text"
            :placeholder="gallery.sport"
            id="sport"
          />

          <label for="price_pack">Precio pack</label>
          <input
            v-model.trim="gallery.price_pack"
            type="numeric"
            :placeholder="gallery.price_pack"
            id="price_pack"
          />

          <label for="price_photo">Precio foto individual</label>
          <input
            v-model.trim="gallery.price_photo"
            type="numeric"
            :placeholder="gallery.price_photo"
            id="price_photo"
          />

          <label for="dates">Imagen cabecera</label>

          <img :src="imageUrl" />

          <file-upload
          v-if="userProfile.role === 'admin'"
            class="has-margin-bottom-2"
            v-bind:accept="'image/*'"
            v-bind:prefix="'gallery-info'"
            v-bind:gallery-id="gallery.id"
            v-bind:multiple="false"
            @uploaded="onUploaded"
          ></file-upload>

          <button :disabled="updating || userProfile.role !== 'admin'" @click="updateGallery" class="button is-primary">
            Modificar Galería
            <i v-if="updating" class="material-icons timelapse">timelapse</i>
          </button>
        </form>
        <button :disabled="updating || userProfile.role !== 'admin'" @click="duplicateGallery" class="button is-warning">
          Duplicar Galería
          <i v-if="updating" class="material-icons timelapse">timelapse</i>
        </button>
        <br>
        <button :disabled="updating || userProfile.role !== 'admin'" @click="deleteGallery" class="button is-danger">
          Borrar Galería
          <i v-if="updating" class="material-icons timelapse">timelapse</i>
        </button>
        
      </div>
      <!-- <pre>
        {{ gallery}}
      </pre> -->
      <div class="col1">
        <h3>Campos de búsqueda avanzada</h3>
        <form v-on:submit.prevent="addField">          
          <select class="select" v-model="typeToAdd" @change="onListTypeChange($event)"
          v-bind:readonly="editingFieldCode !== '' ? true : false"
          v-bind:disabled="editingFieldCode !== '' || userProfile.role !== 'admin' ? true : false"
          >
            <option disabled value="">-- Selecciona un tipo --</option>
            <option v-for="option in typesToAdd" v-bind:key="option.value" v-bind:value="option.value">
              {{ option.text }}
            </option>
          </select>
          <input
            type="text"
            class="zinput"
            placeholder="Codígo"
            required            
            v-bind:readonly="editingFieldCode !== '' || !canEditCode ? true : false"
            v-bind:disabled="editingFieldCode !== '' || !canEditCode || userProfile.role !== 'admin' ? true : false"
            v-model="codeToAdd"
          />
          <div class="help">Mejor en minúsculas sin espacios ni carácteres especiales</div>
          <input
            type="text"
            class="zinput"
            placeholder="Texto"
            required
            :disabled="userProfile.role !== 'admin'"
            v-model="textToAdd"
          />
          <input
            type="text"
            class="zinput"
            placeholder="EXIF"
            :disabled="userProfile.role !== 'admin'"
            v-model="exifToAdd"
          />
          <button type="submit" :disabled="!canAdd || userProfile.role !== 'admin'" class="add button is-warning">Añadir</button>
          <button type="button" :disabled="userProfile.role !== 'admin'" v-on:click="addColorField" class="add add-color button is-warning">Añadir color</button>
          
        </form>

        <hr>

        <div class="tag-cont" v-for="(field, i) in fieldsToAdd" v-bind:key="i">
          <div class="tag tag-field is-warning" @click="editField(field)">
            {{ field.code }} - {{ field.text }} {{ field.exif ? ' (EXIF:' + field.exif + ')' : '' }}
          </div>
          <button class="delete" v-if="userProfile.role == 'admin'" v-on:click="deleteField(i)"></button>
          <div
            class="tag-cont"
            v-for="(value, j) in field.values"
            v-bind:key="j"
          >
            <div class="tag tag-field is-danger" @click="editValue(field, value, i)">
              {{ value.code }} - {{ value.text }} {{ value.from ? ' (' + value.from + '-' + value.to + ')' : '' }}
            </div>
            <button class="delete" v-if="userProfile.role == 'admin'" v-on:click="deleteValue(i, j)"></button>
          </div>
          <form v-on:submit.prevent="addValue(field.code, i)">
            <input
              type="text"
              class="zinput"
              placeholder="Código del valor"
              required
              v-model="codeValueToAdd[i]"
              v-bind:readonly="editingValueCode !== '' ? true : false"
              v-bind:disabled="editingValueCode !== '' ? true : false"
            />
            <div class="help">Mejor en minúsculas sin espacios ni carácteres especiales</div>
            <input
              type="text"
              class="zinput"
              placeholder="Texto del valor"
              required
              v-model="textValueToAdd[i]"
            />
            <input
              type="text"
              class="zinput"
              placeholder="Asignar si dorsal desde"
              v-model="fromValueToAdd[i]"
            />
            <input
              type="text"
              class="zinput"
              placeholder="Asignar si dorsal hasta"
              v-model="toValueToAdd[i]"
            />
            <button type="submit" class="add button is-danger" :disabled="userProfile.role !== 'admin'">Añadir</button>
          </form>

          <hr>
        </div>
        <i class="material-icons clickable" @click="showCode">code</i>
        <pre v-if="showPre">
          {{ gallery }}
        </pre>
        <!-- <hr>
        <button @click="saveList" class="add button is-primary">Save Search Fields</button> -->
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
const fb = require("../firebase");
import axios from "axios";
import { EventBus } from "../services/event-bus.js";
import FileUpload from "@/components/FileUpload.vue";
import firebase from "firebase";
//const fb = require("../firebase");
const storage = firebase.storage();
const storageRef = firebase.storage().ref();

export default {
  components: {
    FileUpload,
  },
  data() {
    return {
      galleryId: "",
      gallery: {},
      showSuccess: false,
      imageUrl: "",
      fieldsToAdd: [],
      typeToAdd: "",
      typesToAdd: [        
        { text: 'Lista', value: 'list' },
        { text: 'Color camiseta', value: 'color-tshirt' },
        //{ text: 'Pants Color', value: 'color-pants' },
      ],
      canEditCode: true,
      codeToAdd: "",
      textToAdd: "",
      exifToAdd: "",
      codeValueToAdd: [],
      textValueToAdd: [],
      fromValueToAdd: [],
      toValueToAdd: [],
      editingFieldCode: "",
      editingValueCode: "",
      showPre: false,
      updating: false
    };
  },
  computed: {
    ...mapState(["userProfile"]),
    canAdd () {
      return this.codeToAdd !== 'color-tshirt' && this.codeToAdd !== 'color-pants'
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.galleryId = this.$route.params.id;
      this.viewGallery();
    }

    EventBus.$on("file-uploaded", (info) => {
      this.onFileUploaded(info);
    });
  },
  methods: {
    viewGallery() {
      fb.galleriesCollection
        .doc(this.galleryId)
        .get()
        .then((doc) => {
          if (doc.exists) {
            this.gallery = doc.data();
            this.gallery.id = this.galleryId;

            if (this.gallery.detectColors == null) {
              this.gallery.detectColors = true
            }

            
            //this.galleryName = this.gallery.name;

            this.loadImage();

            this.initLists();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async updateGallery() {
      if (this.gallery.name !== "") {
        this.updating = true
        const res = await fb.galleriesCollection.doc(this.galleryId).update({
          name: this.gallery.name,
          visible: this.gallery.visible,
          detectText: this.gallery.detectText,
          detectColors: this.gallery.detectColors,
          numbersFrom: this.gallery.numbersFrom,
          numbersTo: this.gallery.numbersTo,
          description: this.gallery.description ? this.gallery.description : "",
          place: this.gallery.place ? this.gallery.place : "",
          dates: this.gallery.dates ? this.gallery.dates : "",
          image: this.gallery.image ? this.gallery.image : "",
          sport: this.gallery.sport ? this.gallery.sport : "",
          gmt: this.gallery.gmt ? this.gallery.gmt : 0,
          date_start: this.gallery.date_start ? this.gallery.date_start : "",
          date_end: this.gallery.date_end ? this.gallery.date_end : "",
          price_pack: this.gallery.price_pack ? this.gallery.price_pack : 0,
          price_photo: this.gallery.price_photo ? this.gallery.price_photo : 0,
          validateNumbersToBuy: this.gallery.validateNumbersToBuy ? this.gallery.validateNumbersToBuy : false,
        });

        const productsCreation = {
          product_name : this.gallery.name,
          gallery_id   : this.galleryId,
          price_pack   : this.gallery.price_pack ? this.gallery.price_pack : 0,
          price_photo  : this.gallery.price_photo ? this.gallery.price_photo : 0,
          image: this.imageUrl ? this.imageUrl : '',
          image_name: this.gallery.image ? this.gallery.image : "",
        }
        const findResp = await axios.post('https://www.findupix.com/wp-json/wc/v3/custom', productsCreation)
        this.$swal("¡Hecho!");
        this.updating = false
        if (!findResp.data || (findResp.data && !findResp.data.status)) {
          await this.$swal({
            title: "Error ",
            text: `Parece que ha habido un error en findupix.com al actualizar el producto`,
            icon: "warning"
          }
          );
        }
      }
      this.showEdit = false;
    },
    async duplicateGallery() {
      if (this.gallery.name !== "") {
        const doc = await fb.galleriesCollection.doc(this.galleryId).get();
        if (doc.exists) {
          const newGallery = doc.data();
          newGallery.createdOn = new Date();
          newGallery.name += ' (copia)';
          newGallery.photos = 0
          newGallery.photos_detected = 0
          await fb.galleriesCollection.add(newGallery)
          this.$swal("¡Hecho!");

          this.$router.push('/')
        }

        
      }
      this.showEdit = false;
    },
    async deleteGallery() {
      const result = await this.$swal({
        title: "Eliminar?",
        text: `¿Está seguro de borrar la galería?`,
        icon: "question",
        confirmButtonText: "Yes",
        showCancelButton: true,
        cancelButtonText: "No",
      });
      if (result.value) {
        const galleryRef = await fb.galleriesCollection
          .doc(this.galleryId)
          .update({
            deleted: true,
            visible: false,
          });
        this.$router.push("/");
      }
    },
    onUploaded(info) {
      //console.log("onUploaded info", info);
    },
    onFileUploaded(info) {
      //console.log("file-uploaded", info);
      if (info && info.name) {
        this.gallery.image = info.name;
        this.loadImage();
      }
    },
    async loadImage() {
      if (this.gallery.image && this.gallery.image !== "") {
        var fileRef = storage.ref(
          `gallery-info/${this.gallery.id}/${this.gallery.image}`
        );
        this.imageUrl = await fileRef.getDownloadURL();
      }
    },
    async addField() {
      if (!this.codeToAdd) {
        return
      }
      const field = this.fieldsToAdd.find((f) => f.code.toLowerCase() === this.codeToAdd.toLowerCase());

      if (field) {
        field.text = this.textToAdd
        field.exif = this.exifToAdd
      }
      else {
        const fieldToAdd = {
          code: this.codeToAdd.toLowerCase(),
          text: this.textToAdd,
          exif: this.exifToAdd,
          values: [],
        };
        this.fieldsToAdd.push(fieldToAdd);
        this.codeValueToAdd.push('');
        this.textValueToAdd.push('');
        this.fromValueToAdd.push('');
        this.toValueToAdd.push('');
      }
      
      this.codeToAdd = '';
      this.textToAdd = '';
      this.exifToAdd = '';
      this.editingFieldCode = '';

      this.saveList()
    },
    async addColorField() {
      const field = this.fieldsToAdd.find((f) => f.code.toLowerCase() === this.codeToAdd.toLowerCase());

      if (field) {
        field.text = this.textToAdd
      }
      else {
        const fieldToAdd = {
          code: this.codeToAdd.toLowerCase(),
          text: this.textToAdd,
          exif: this.exifToAdd,
          values: [
            {
              code: 'blue',
              text: 'Azul',
            },
            {
              code: 'red',
              text: 'Rojo',
            },
            {
              code: 'brown',
              text: 'Marrón',
            },
            {
              code: 'green',
              text: 'Verde',
            },
            {
              code: 'violet',
              text: 'Violeta',
            }
            ,
            {
              code: 'yellow',
              text: 'Amarillo',
            }
            ,
            {
              code: 'grey',
              text: 'Gris',
            }
            ,
            {
              code: 'orange',
              text: 'Naranja',
            }
            ,
            {
              code: 'white',
              text: 'Blanco',
            }
            ,
            {
              code: 'black',
              text: 'Negro',
            }
          ],
        };
        this.fieldsToAdd.push(fieldToAdd);
        this.codeValueToAdd.push('');
        this.textValueToAdd.push('');
        this.fromValueToAdd.push('');
        this.toValueToAdd.push('');
      }
      
      this.codeToAdd = '';
      this.textToAdd = '';
      this.exifToAdd = '';
      this.editingFieldCode = '';

      this.saveList()
    },
    async addValue(fieldCode, i) {
      
      const value = this.fieldsToAdd.find((f) => f.code.toLowerCase() === fieldCode.toLowerCase()).values.find(v => v.code.toLowerCase() == this.codeValueToAdd[i].toLowerCase());

      if (value) {
        value.text = this.textValueToAdd[i]
        value.from = this.fromValueToAdd[i] ? this.fromValueToAdd[i] : false
        value.to = this.toValueToAdd[i] ? this.toValueToAdd[i] : false
      }
      else {
        const valueToAdd = {
          code: this.codeValueToAdd[i].toLowerCase(),
          text: this.textValueToAdd[i],
          from: this.fromValueToAdd[i] ? this.fromValueToAdd[i] : false,
          to: this.toValueToAdd[i] ? this.toValueToAdd[i] : false,
        };
        const field = this.fieldsToAdd.find((f) => f.code.toLowerCase() === fieldCode.toLowerCase());
        field.values.push(valueToAdd);
      }

      
      //this.fieldsToAdd.push(fieldToAdd)
      this.codeValueToAdd = this.codeValueToAdd.map(v => '');
      this.textValueToAdd = this.textValueToAdd.map(v => '');
      this.fromValueToAdd = this.fromValueToAdd.map(v => '');
      this.toValueToAdd = this.toValueToAdd.map(v => '');
      this.editingValueCode = '';

      this.saveList()
    },
    async editField(field) {
      this.editingFieldCode = field.code
      this.codeToAdd = field.code;
      this.textToAdd = field.text;
      this.exifToAdd = field.exif;
    },
    async editValue(field, value, i) {      
      this.editingValueCode = value.code

      this.codeValueToAdd = this.codeValueToAdd.map(v => '');
      this.textValueToAdd = this.textValueToAdd.map(v => '');
      this.fromValueToAdd = this.fromValueToAdd.map(v => '');
      this.toValueToAdd = this.toValueToAdd.map(v => '');

      this.codeValueToAdd[i] = value.code
      this.textValueToAdd[i] = value.text
      this.fromValueToAdd[i] = value.from
      this.toValueToAdd[i] = value.to
      // this.codeToAdd = field.code;
      // this.textToAdd = field.text;
    },
    async deleteField(i) {
      this.fieldsToAdd = this.fieldsToAdd.filter((f, idx) => idx !== i)
      this.editingFieldCode = '';
      this.typeToAdd = 'list'
      this.canEditCode = true
      
      this.codeValueToAdd = this.codeValueToAdd.map(v => '');
      this.textValueToAdd = this.textValueToAdd.map(v => '');
      this.fromValueToAdd = this.fromValueToAdd.map(v => '');
      this.toValueToAdd = this.toValueToAdd.map(v => '');

      this.saveList()
    },
    async deleteValue(i, j) {      
      const newValues = this.fieldsToAdd[i].values.filter((v, jdx) => jdx !== j)
      let newFields = JSON.parse(JSON.stringify(this.fieldsToAdd))
      this.fieldsToAdd[i].values = newValues

      this.saveList()
    },
    async saveList() {

      const res = await fb.galleriesCollection.doc(this.galleryId).update({
          searchLists: this.fieldsToAdd
      });
      this.$swal("¡Hecho!");
    },
    initLists() {
      if (this.gallery.searchLists) {
        this.fieldsToAdd = this.gallery.searchLists
      }
      
      this.fieldsToAdd.forEach(f => {
        this.codeValueToAdd.push('')
        this.textValueToAdd.push('')
        this.fromValueToAdd.push('')
        this.toValueToAdd.push('')
      })
      
    },
    onListTypeChange(event) {
      const code = event.target.value
      if (code === 'color-tshirt') {
        this.codeToAdd = code
        this.canEditCode = false
      }
      else if (code === 'color-pants') {
        this.codeToAdd = code
        this.canEditCode = false
      }
      else if (code === 'list') {
        this.codeToAdd = ''
        this.canEditCode = true
      }
    },
    showCode () {
      this.showPre = !this.showPre
    }
  },
};
</script>
<style scoped>
.title {
  margin-top: 1rem;
}
.card-image {
  max-height: 200px;
  width: 100%;
}
.card {
  font-size: 0.85rem;
  border: 2px solid transparent;
  position: relative;
}
.card-text {
  padding: 0.5rem;
}
.gallery {
  margin-top: 1rem;
}
.card:hover {
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.2);
}
.buttons {
  margin-top: 1.5rem;
  text-align: right;
}
.buttons i {
  margin-right: 1rem;
  font-size: 2rem;
  cursor: pointer;
}
.card-selected {
  border: 2px solid #3298dc;
}
.input {
  border: 0;
  border-radius: 0;
  border-bottom: 2px solid hsl(0, 0%, 71%);
  outline: none;
  font-size: 1.5rem;
}
.input:focus,
.input:active {
  border-bottom: 2px solid hsl(171, 100%, 41%);
  outline: none;
  box-shadow: none;
}
.stats {
  color: #6c757d;
  margin-bottom: 1rem;
}
.stats .tag {
  margin-right: 0.5rem;
  cursor: pointer;
  font-size: 0.9rem;
}
.stats .tag.tag-selected {
  font-weight: bold;
}
.xtextarea {
  margin-bottom: 1rem;
}
h3 {
  font-weight: bold;
  margin-bottom: 1.5rem;
}
.main-container {
  margin-top: 70px;
}
.column-settings,
.column-list {
  background-color: #fff;
}
.col1 {
  border: 2px solid #eee;
  border-radius: 4px;
}
.tag-field {
  padding: 1rem 2rem;
  font-size: 1rem;
  margin-bottom: 0rem;
  cursor: pointer;
}
.tag-cont {
  margin-top: 0.5rem;
}
#settings form {
  margin-bottom: 0.5rem;
}
#settings .button{
  margin-top: 1rem;
}
.delete{
  margin-top: 6px;
  margin-left: 4px;
}
.add-color{
  margin-left: 1rem;
}
.select{
 display: block;
width: 100%;
margin-bottom: 1rem;
font-size: 16px;
padding: 10px;
outline: 0;
border: 1px solid #e6ecf0;
border-radius: 3px; 
}
.help{
  color: #999;
  margin-bottom: 1rem;
  margin-top: -0.5rem;
}
</style>
